module.exports = __webpack_public_path__ + "resources/img/img-tmax-hyper-sql-for-postgre-sql-02-jp.37369b9da3b964b7c6df05e9a70db4de.png";